class ShiftTemplateService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/avg/shift-template', params);
  }

  getByID(params) {
    return this.apiService.get(`/api/v1/avg/shift-template/${params}`);
  }

  create(params) {
    return this.apiService.post('/api/v1/avg/shift-template', params);
  }

  update(params) {
    return this.apiService.put(`/api/v1/avg/shift-template/${params.id}`, params);
  }

  remove(params) {
    return this.apiService.delete('/api/v1/avg/shift-template', params);
  }
}

export default ShiftTemplateService;
